import { createAction, props } from '@ngrx/store';
import { IDjangoErrors } from '../../../../shared/models/DjangoErrors';
import {
  NotificationResponse,
  NotificationPreferenceResponse,
  NotificationPreferenceUpdateResponse,
} from '../../models/Notifications';

export enum NotificationsApiActionTypes {
  GetNotificationsSuccess = '[Notifications API] Get Notifications Success',
  GetNotificationsFailure = '[Notifications API] Get Notifications Failure',
  GetNotificationPreferencesSuccess = '[Notifications API] Get Notification Preferences Success',
  GetNotificationPreferencesFailure = '[Notifications API] Get Notification Preferences Failure',
  UpdateNotificationPreferencesSuccess = '[Notifications API] Update Notification Preferences Success',
  UpdateNotificationPreferencesFailure = '[Notifications API] Update Notification Preferences Failure',
  MarkNotificationsReadSuccess = '[Notifications API] Mark Notifications Read Success',
  MarkNotificationsReadFailure = '[Notifications API] Mark Notifications Read Failure',
}

export const GetNotificationsSuccess = createAction(
  NotificationsApiActionTypes.GetNotificationsSuccess,
  props<{ payload: NotificationResponse }>()
);

export const GetNotificationsFailure = createAction(
  NotificationsApiActionTypes.GetNotificationsFailure,
  props<{ errors: IDjangoErrors }>()
);

export const GetNotificationPreferencesSuccess = createAction(
  NotificationsApiActionTypes.GetNotificationPreferencesSuccess,
  props<{ payload: NotificationPreferenceResponse[] }>()
);

export const GetNotificationPreferencesFailure = createAction(
  NotificationsApiActionTypes.GetNotificationPreferencesFailure,
  props<{ errors: IDjangoErrors }>()
);

export const UpdateNotificationPreferencesSuccess = createAction(
  NotificationsApiActionTypes.UpdateNotificationPreferencesSuccess,
  props<{ payload: NotificationPreferenceResponse[] | NotificationPreferenceUpdateResponse }>()
);

export const UpdateNotificationPreferencesFailure = createAction(
  NotificationsApiActionTypes.UpdateNotificationPreferencesFailure,
  props<{ errors: IDjangoErrors }>()
);

/** `count` is the user's unread total after the update. */
export const MarkNotificationsReadSuccess = createAction(
  NotificationsApiActionTypes.MarkNotificationsReadSuccess,
  props<{ ids: number[]; count: number }>()
);

export const MarkNotificationsReadFailure = createAction(
  NotificationsApiActionTypes.MarkNotificationsReadFailure,
  props<{ errors: IDjangoErrors }>()
);
